import 'jsrender';
import { DetectIE } from 'Utils/device-utils';
import * as analytics from 'Utils/analytics';


/* jQuery plugin widgetHotelThemesBoxes
*  required: jQuery, jsRender
*  
*  Documentation of jsRender API: https://www.jsviews.com/#jsrapi
*  Examples of jsRender: https://www.jsviews.com/#download/pages-jsr-jq
*  
*/
(function ($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original splice()

    //function GetBreakpointWidth() {
    //    //var bp_Width = $(window).width();
    //    var bp_Width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    //    return bp_Width;
    //}

    //function GetBreakpointHeight() {
    //    //var bp_Height = $(window).height();
    //    var bp_Height = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
    //    return bp_Height;
    //}

    function init_slider(actionbox) {
        var actionboxElement = actionbox.actionboxElement,
            $holder = actionboxElement.find('.' + actionbox.holderClassName),
            $slider = actionbox.$slider;

        let $images = $slider.find('img, .lazyload');
        if ($images && $images.length > 0) {
            $images.each(function (i, el) {
                if (el.hasClass('lazydefer')) {
                    el.removeClass('lazydefer');
                }
                el.style.removeProperty('visibility');
                el.style.removeProperty('display');
            });
        }

        $holder.hide();
        $slider.show();
        actionbox.$holder = $holder;
        $holder.detach();

        let $moreButton = actionboxElement.find('.' + actionbox.moreButtonClassName);
        if (actionbox.countRows > actionbox.limits) {
            $moreButton.css("display", "block");
        } else {
            $moreButton.css("display", "none");
        }
        actionbox.$moreButton = $moreButton;

        update_slimmage();
        
        AppLoader.ready(function () {
            track_view_item_list(actionbox);
        });
    }
    function destroy_slider(actionbox) {
        var actionboxElement = actionbox.actionboxElement,
            $holder = actionboxElement.find('.' + actionbox.holderClassName),
            $slider = actionbox.$slider;
        if ($holder.length < 1 && actionbox.$holder) {
            $holder = actionbox.$holder;
            $holder.appendTo(actionboxElement);
        }

        let $moreButton = actionboxElement.find('.' + actionbox.moreButtonClassName);
        if ($moreButton.length < 1 && actionbox.$moreButton) {
            $moreButton = actionbox.$moreButton;
            $moreButton.css("display", "none");
        }

        $slider.hide();
        $holder.show();

        $slider.empty();
    }

    function get_hotel_item(hotelCard) {
        return {
            Id: hotelCard.HotelId,
            PageId: hotelCard.PageId,
            Name: hotelCard.Name,
            DestinationName: hotelCard.DestinationName,
            Concept: !hotelCard.Concept ? null : {
                Id: hotelCard.Concept.Id,
                Code: hotelCard.Concept.Code,
                Name: hotelCard.Concept.Name,
            }
            //hotel.ArrivalDate
        };
    }

    function track_view_item_list(actionbox) {
        if (!actionbox.ga_event || actionbox.ga_event == '') {
            return;
        }
        if (actionbox.ga_event != 'view_item_list') {
            return;
        }

        var $slider = actionbox.$slider,
            $items = $slider.find('.actionbox__item');
        
        //console.log('>>> more-items $items', $items);
        var items = actionbox.request.data.Items;

        var hotelList = [];
        if ($items && $items.length > 0) {
            $items.each(function (i, el) {
                var $el = $(el);
                if ($el.is(":visible")) {
                    let hotelId = $el.attr('data-hotelId');
                    if (hotelId && hotelId != '') {
                        hotelId = parseInt(hotelId);
                        if (!isNaN(hotelId)) {
                            let matches = $.grep(items, function (item, i) {
                                return hotelId == item.HotelId;
                            });
                            if (matches && matches.length > 0) {
                                let ga_item = get_hotel_item(matches[0]);
                                if (ga_item) {
                                    hotelList.push(ga_item);
                                }
                            }
                        }
                    }
                }
            });
        }
        //console.log('>>> more-items hotelList', hotelList);

        let ga_itemList = analytics.getItemList();
        let list_id = AppData.CurrentPageId;
        let list_name = '';
        let destinationName = '';

        if (ga_itemList) {
            if (ga_itemList.item_list_id && ga_itemList.item_list_id != '') {
                list_id = ga_itemList.item_list_id;
            }

            if (ga_itemList.item_list_name && ga_itemList.item_list_name != '') {
                list_name = ga_itemList.item_list_name;
            }
        }

        if (actionbox.ga_list_id && actionbox.ga_list_id != '') {
            //if (list_id && list_id != '') {
            //    list_id += '_' + actionbox.ga_list_id;
            //} else {
            //    list_id = actionbox.ga_list_id;
            //}
            list_id = actionbox.ga_list_id;
        }

        if (actionbox.ga_list_name && actionbox.ga_list_name != '') {
            //if (list_name && list_name != '') {
            //    list_name += '_' + actionbox.ga_list_name;
            //} else {
            //    list_name = actionbox.ga_list_name;
            //}
            list_name = actionbox.ga_list_name;
        }

        let departureAirportCode = '';
        let totalPersons = 0;
        let hotelOnly = true;
        let isDirectFlight = false;

        if (typeof searchViewModel != "undefined" && searchViewModel) {
            departureAirportCode = searchViewModel.DepartureAirportCode();
            totalPersons = searchViewModel.TotalPersons();
            hotelOnly = searchViewModel.HotelOnly();
            isDirectFlight = searchViewModel.IsDirectFlight();
        }

        // let currentPage = searchViewModel ? searchViewModel.CurrentPage() : null;
        // if (currentPage) {
        //     destinationName = currentPage.Title();
        // }

        let itemList = {
            id: list_id,
            name: list_name,
            DepartureAirportCode: departureAirportCode,
            DestinationName: destinationName,
            TotalPersons: totalPersons,
            HotelOnly: hotelOnly,
            IsDirectFlight: isDirectFlight
        };
        analytics.trackViewItemList(hotelList, itemList);
    }

    function update_slimmage() {
        if (window.slimmage.checkResponsiveImages) {
            window.slimmage.checkResponsiveImages();
        }

        if (typeof imgix !== "undefined") {
            imgix.init();
        }

        if (typeof lazySizes !== "undefined") {
            lazySizes.loader.checkElems();
        }
    }

    function requestData(actionbox) {
        if (!actionbox)
            return;

        if (!actionbox.request)
            actionbox.request = {};

        var jqxhr = actionbox.request.jqxhr;
        // cancel executing request before start new request 
        if (jqxhr) {
            if (typeof jqxhr.abort != "undefined")
                jqxhr.abort();
        }

        actionbox.request.requesting = true;
        actionbox.request.failed = false;
        actionbox.request.ready = false;

        var js = actionbox.request.parameters;
        var jsondata = JSON.stringify(js);

        jqxhr = $.ajax({
            url: actionbox.request.url,
            type: actionbox.request.type, //'POST',
            data: jsondata,
            contentType: 'application/json',
            headers: { 'Accept': 'application/json' },
            success: function (data) {
                if (data && data.Redirect && data.RedirectUrl != '') {
                    if (typeof ga != "undefined") {
                        ga('send', 'event', 'Basket ' + self.RequestType(), 'Redirected', self.GetRequestDetailsByParams());
                    }
                    //window.location.href = data.RedirectUrl;
                    window.location = data.RedirectUrl;
                    return;
                }

                var success = false;
                actionbox.request.data = data;
                if (!data || data.length == 0) {
                    actionbox.request.ready = false;
                    actionbox.request.failed = true;
                    actionbox.request.requesting = false;
                } else {
                    if (typeof data.Success != "undefined") {
                        success = data.Success; // use Success if this property exists
                    } else {
                        success = true; // keep previous logic-way
                    }
                    
                    actionbox.request.failed = false;
                    actionbox.request.ready = true;
                    actionbox.request.requesting = false;
                }
                if (success) {
                    updateWithData(actionbox);
                    init_slider(actionbox);
                }

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(success);
            },
            error: function (data, textStatus, errorThrown) {
                actionbox.request.data = data;
                actionbox.request.ready = false;
                actionbox.request.failed = true;
                actionbox.request.requesting = false;

                if (typeof actionbox.request.callback == "function")
                    actionbox.request.callback(false);
            }
        }).always(function () {
            actionbox.request.jqxhr = null;
        });
        actionbox.request.jqxhr = jqxhr;
    }

    function updateWithData(actionbox) {
        //console.log('updateWithData', actionbox);

        var actionboxElement = actionbox.actionboxElement,
            $slider = actionbox.$slider,
            $template = actionboxElement.find('[data-template="actionbox_item"]');

        var tmpl = $.templates($template.html());   // Get compiled template
        var data = actionbox.request.data.Items;    // Define data
        //var html = tmpl.render(data);               // Render template using data - as HTML string
        //$slider.html(html);                         // Insert HTML string into DOM
        actionbox.templates["actionbox_item"] = $template;
        $template.detach();

        let rows = [];
        let rowIndex = -1;
        let rowClass = "";
        let rowGroup = -1;
        let numInside = -1;
        let $row = null; //$('<div></div>').addClass('card-columns');

        let ROW_STYLE_1 = "xdefault";
        let ROW_STYLE_2 = "xgroup2";
        let ROW_STYLE_3 = "xgroup3";

        let ROW_MAX_ITEMS = {
            1: 4, // inside ROW_STYLE_1
            2: 4, // inside ROW_STYLE_2
            3: 5  // inside ROW_STYLE_3
        };

        data.forEach(function (item, i) {
            let $col = $('<div></div>')
                //.addClass('col-12 card');
                .addClass('bp0-col-12 bp2-col-6 bp3-col-4 bp4-col-4');
            //let num = i + 1;
            let is_large = false;
            
            let maxItems = ROW_MAX_ITEMS[rowGroup];
            if (!maxItems || maxItems == 0) {
                console.warn('wrong number of maxItems. reset to 1.');
                maxItems = 1; // avoid division by zero
            }
            if (i == 0 || (numInside % maxItems == 0)) {
                rowIndex++;
                let numGrp = rowIndex + 1;
                numInside = 0;
                
                if (actionbox.limits > 0) {
                    $row = $('<li></li>')
                        //.addClass('card-columns');
                        //.addClass('row-narrow');
                        .addClass('slide-group');
                    $row.attr('data-grp-index', rowIndex);
                    rows.push($row);
                } else {
                    $row = $('<div></div>')
                        //.addClass('card-columns');
                        //.addClass('row-narrow');
                        .addClass('slide-group');
                    $row.attr('data-grp-index', rowIndex);
                    rows.push($row);
                }

                // row styles ...
                rowGroup++;
                if (rowGroup < 1 || rowGroup > 3) {
                    rowGroup = 1;
                }
                rowClass = ROW_STYLE_1;
                switch (rowGroup) {
                    case 3:
                        rowClass = ROW_STYLE_3;
                        break;

                    case 2:
                        rowClass = ROW_STYLE_2;
                        break;

                    case 1:
                    default:
                        rowClass = ROW_STYLE_1;
                        break;
                }
                $row.addClass(rowClass);

                if (actionbox.limits > 0 && numGrp > actionbox.limits) {
                    $row.addClass('hidden');
                }

            }
            numInside++;

            let update_col_style_1 = function (num_inside) {
                if (num_inside % 4 == 0) {
                    //$col.addClass('xright');
                    //is_large = true;
                    $col.addClass('xbottom');
                } else if (num_inside % 3 == 0) {
                    //$col.addClass('xbottom');
                    $col.addClass('xright');
                    is_large = true;
                } else if (num_inside % 2 == 0) {
                    $col.addClass('xtop');
                } else {
                    $col.addClass('xleft');
                    is_large = true;
                }
            };

            let update_col_style_2 = function (num_inside) {
                if (num_inside % 4 == 0) {
                    $col.addClass('xbottom');
                } else if (num_inside % 3 == 0) {
                    $col.addClass('xtop');
                } else if (num_inside % 2 == 0) {
                    //$col.addClass('xleft');
                    is_large = true;
                } else {
                    //$col.addClass('xleft');
                    is_large = true;
                }
            };

            let update_col_style_3 = function (num_inside) {
                if (num_inside % 5 == 0) {
                    //$col.addClass('xright');
                    //is_large = true;
                    $col.addClass('xbottom');
                } else if (num_inside % 4 == 0) {
                    $col.addClass('xbottom');
                } else if (num_inside % 3 == 0) {
                    //$col.addClass('xtop');
                    $col.addClass('xright');
                    is_large = true;
                } else if (num_inside % 2 == 0) {
                    //$col.addClass('xbottom');
                    $col.addClass('xtop');
                } else {
                    $col.addClass('xtop');
                }
            };

            switch (rowClass) {
                case ROW_STYLE_3:
                    update_col_style_3(numInside);
                    break;

                case ROW_STYLE_2:
                    update_col_style_2(numInside);
                    break;

                case ROW_STYLE_1:
                default:
                    update_col_style_1(numInside);
                    break;
            }


            item.is_large = is_large;
            if (is_large) {
                if (item.Class && item.Class.length > 0)
                    item.Class += " large";
                else
                    item.Class = "large";
                $col.addClass('xlarge');
            }
            let html = tmpl.render(item);
            $col.html(html);
            //$col.addClass('hotel-theme__slide');
            $col.attr('data-index', i);

            $row.append($col);
        });

        actionbox.countRows = rows.length;
        //$slider.prepend($row);
        $slider.addClass('row-narrow');
        for (var i = 0; i < rows.length; i++) {
            $slider.append(rows[i]);
        }
    }


    var defaults = {
        sliderClassName: 'slider',
        holderClassName: 'holder',
        request: {
            url: '',
            type: 'GET',
            parameters: null,
            //jqxhr: null,
            //data: data,
            //ready: false,
            //failed: false,
            //requesting: false
        },
        limits: null,
        //moreButtonClassName: 'btn-more-container',
        //moreItemsClassName: 'more-items',
        templates: {},
        ga_event: '',
        ga_list_id: '',
        ga_list_name: '',
    },
        //$window = $(window),
        //$document = $(document),
        actionboxs = [],
        //scroller = function () {
        //    //console.log('actionbox-slider scroller()');
        //},
        //resizer = function () {
        //    //console.log('actionbox-slider resizer()');
        //    //for (var i = 0, l = actionboxs.length; i < l; i++) {
        //    //    var s = actionboxs[i];
        //    //    //update_slider(s);
        //    //    update_slides(s);
        //    //}
        //    //update sidebar after resize
        //    scroller();
        //},
        methods = {
            init: function (options) {
                return this.each(function () {
                    var o = $.extend({}, defaults, options);
                    var actionboxElement = $(this);

                    let attr_limits = actionboxElement.attr('data-limits');
                    if (attr_limits && attr_limits.length > 0) {
                        o.limits = parseInt(attr_limits);
                    }

                    let attr_ga_event = actionboxElement.attr('data-ga_event');
                    if (attr_ga_event && attr_ga_event.length > 0) {
                        o.ga_event = attr_ga_event;
                    }

                    let attr_ga_list_id = actionboxElement.attr('data-ga_list_id');
                    if (attr_ga_list_id && attr_ga_list_id.length > 0) {
                        o.ga_list_id = attr_ga_list_id;
                    }

                    let attr_ga_list_name = actionboxElement.attr('data-ga_list_name');
                    if (attr_ga_list_name && attr_ga_list_name.length > 0) {
                        o.ga_list_name = attr_ga_list_name;
                    }

                    var actionboxId = actionboxElement.attr('id');
                    var sliderId = actionboxId ? actionboxId + '-' + defaults.sliderClassName : defaults.sliderClassName;
                    var $slider = $(o.limits > 0 ? '<ul></ul>' : '<div></div>')
                        .attr('id', sliderId)
                        .css('display', 'none')
                        .addClass(o.sliderClassName);
                    actionboxElement.prepend($slider);

                    var flgIE = DetectIE() !== false;
                    if (flgIE) {
                        actionboxElement.addClass('IE');
                    }

                    if (o.limits > 0) {
                        $slider
                            .attr('data-limits', o.limits)
                            .addClass(o.moreItemsClassName);
                        $slider.on('more-items.show-more-items', function(event, data) {
                            //console.log('>>> more-items arguments: ', arguments);
                            track_view_item_list(o);
                        });
                    }

                    if (o.request && o.request.url.length > 0 && o.request.parameters) {
                        requestData(o);
                    } else {
                        o.request = {};

                        let attrItems = actionboxElement.attr('data-items');
                        if (attrItems && attrItems.length > 0) {
                            o.request.data = window.AppData.widgetHotelThemesBoxes[attrItems];
                        }
                        // emulate success/error callback(s) of request
                        setTimeout(function () {
                            if (o.request.data) {
                                // success
                                o.request.failed = false;
                                o.request.ready = true;
                                o.request.requesting = false;
                                updateWithData(o);
                                init_slider(o);
                            } else {
                                // error
                                o.request.ready = false;
                                o.request.failed = true;
                                o.request.requesting = false;
                            }
                        }, 64);
                    }

                    o.actionboxElement = actionboxElement;
                    o.$slider = $slider;
                    actionboxs.push(o);
                });
            },
            //update: function () {
            //    scroller.apply(this, arguments);
            //},
            destroy: function (options) {
                return this.each(function () {
                    var that = this;
                    var unactionboxElement = $(that);

                    var removeIdx = -1;
                    var i = actionboxs.length;
                    while (i-- > 0) {
                        if (actionboxs[i].actionboxElement.get(0) === that) {
                            //methods.destroySlider(actionboxs[i]);
                            destroy_slider(actionboxs[i]);
                            actionboxs[i].$slider.remove();
                            actionboxs[i].$slider = null;
                            actionboxs[i].$holder = null;
                            //actionboxs[i].templates = {};
                            //unactionboxElement.removeClass(actionboxs[i].elementClassName);
                            splice.call(actionboxs, i, 1);
                            removeIdx = i;
                        }
                    }
                    if (removeIdx !== -1) {
                        // TODO smth with unactionboxElement styles on destroy
                        //unactionboxElement.unwrap();
                        //unactionboxElement.css({
                        //    'width': '',
                        //    'position': '',
                        //    'top': '',
                        //    'float': '',
                        //    'z-index': ''
                        //});
                    }
                });
            }
        };

    //// should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
    //if (window.addEventListener) {
    //    window.addEventListener('scroll', scroller, false);
    //    window.addEventListener('resize', resizer, false);
    //} else if (window.attachEvent) {
    //    window.attachEvent('onscroll', scroller);
    //    window.attachEvent('onresize', resizer);
    //}

    $.fn.widgetHotelThemesBoxes = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on widgetHotelThemesBoxes');
        }
    };

    //$(function () {
    //    setTimeout(scroller, 0);
    //});
})(jQuery);


/*
widgetHotelThemesBoxes
*/
//AppLoader.ready(function () {
$(document).ready(function () {
    // added some timeout to give time for processing things with higher priorities.
    setTimeout(function () {
        if ($('.widgetHotelThemesBoxes').length > 0) {
            var c = 0;
            $('.widgetHotelThemesBoxes').each(function () {
                var $this = $(this);
                var id = $this.attr('id');
                if (!id || id == '') {
                    //$this.attr('id', 'widgetHotelThemesBoxes-' + c);
                    $this.attr('id', 'whtb-' + c);
                    c++;
                }
            });

            $('.widgetHotelThemesBoxes:not([data-items])').widgetHotelThemesBoxes({
                sliderClassName: 'hotel-themes-boxes',
                holderClassName: 'placeholder',
                request: {
                    url: '/widgets-api/hotelThemes',
                    type: 'POST',
                    parameters: {
                        pageId: AppData.CurrentPageId
                    }
                }
            });
            $('.widgetHotelThemesBoxes[data-items]').widgetHotelThemesBoxes({
                sliderClassName: 'hotel-themes-boxes',
                holderClassName: 'placeholder',
                moreButtonClassName: 'btn-more-container',
                moreItemsClassName: 'more-items'
            });
        }
    }, 500);
});
